exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.file-description[data-v-9fa10ba8] {\n    border-bottom: 1px dotted #000;\n    text-decoration: none;\n    cursor: pointer;\n}\n", ""]);

// exports
